var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2065 3.63397C22.9402 2.14748 25.0598 2.14748 25.7935 3.63397L30.5881 13.3489C30.8794 13.9392 31.4425 14.3483 32.094 14.443L42.815 16.0009C44.4555 16.2392 45.1105 18.2552 43.9235 19.4122L36.1656 26.9743C35.6942 27.4337 35.4791 28.0957 35.5904 28.7445L37.4218 39.4223C37.702 41.0561 35.9872 42.302 34.5199 41.5306L24.9307 36.4893C24.348 36.183 23.652 36.183 23.0693 36.4893L13.4801 41.5306C12.0128 42.302 10.298 41.0561 10.5782 39.4223L12.4096 28.7445C12.5209 28.0957 12.3058 27.4337 11.8344 26.9743L4.07655 19.4122C2.88951 18.2552 3.54453 16.2392 5.18497 16.0009L15.906 14.443C16.5575 14.3483 17.1206 13.9392 17.4119 13.3489L22.2065 3.63397Z",
    fill: "#FFCA28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3176 17.4V15.336H24.1736V27H21.8696V17.4H20.3176Z",
    fill: "#206CC6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1);
export default __webpack_public_path__ + "static/media/star1.c7cea83d84488d4ef0274579a405a823.svg";
export { ForwardRef as ReactComponent };